import { render, staticRenderFns } from "./ServiceTasksListPage.vue?vue&type=template&id=3088a27a&"
import script from "./ServiceTasksListPage.vue?vue&type=script&lang=ts&"
export * from "./ServiceTasksListPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports